const EngineVersion = () => "1.50.1";
export default EngineVersion;
